import React, { Component, useEffect } from 'react';
import './App.css';
import Home from '../home/home';
import FormCreate from '../fromCreate/formCreate';
import HomeAssign from '../homeAssign/homeAssign';
import HomeToDo from "../homeTodo/homeTodo";
import Detail from '../detail/detail';
import Edit from '../edit/edit';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
window.Buffer = window.Buffer || require("buffer").Buffer;

function App(){
  useEffect(() => {
    window.contact = (e) => {
      console.log(e);
    }
  
  
  }, []);
  
  
    return (
      <Router>
        <div className="content">
          <Routes>
            <Route exact path='/' element={< Home />}></Route>
            <Route exact path='/create' element={< FormCreate />}></Route>
            <Route exact path='/assign' element={< HomeAssign />}></Route>
            <Route exact path='/todo' element={< HomeToDo />}></Route>
            <Route exact path='/detail' element={< Detail />}></Route>
            <Route exact path='/edit' element={<Edit />}></Route>
          </Routes>
        </div>
      </Router>
    );

}

export default App;
